import { ref } from "vue";
import useQuasar from 'quasar/src/composables/use-quasar.js';;
export function useMsg() {
  const $q = useQuasar();
  let message = ref({
    type: "",
    message: "",
  });
  const success = (msg) => {
    message.value.type = "positive";
    message.value.message = msg;
  };
  const warning = (msg) => {
    message.value.type = "warning";
    message.value.message = msg;
  };
  const error = (msg) => {
    message.value.type = "negative";
    message.value.message = msg;
  };
  const info=(msg)=>{
    message.value.type = "info";
    message.value.message = msg;
  }

  const Success = (msg) => {
    $q.notify({
      type: "positive",
      message: msg,
    });
  };

  const Warning = (msg) => {
    $q.notify({
      type: "warning",
      message: msg,
    });
  };

  const Error = (msg) => {
    $q.notify({
      type: "negative",
      message: msg,
    });
  };

  const Info = (msg) => {
    $q.notify({
      type: "info",
      message: msg,
    });
  };


  return { message,info, success, warning, error, Success, Warning, Error,Info };
}
